import { Injectable } from '@angular/core';
import { SimpleDate } from '@app/core/models';

import * as moment from 'moment';
import { MomentObjectOutput } from 'moment';
import { Clock } from '@app/core/services/clock.service';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor(private clock: Clock) { }

  getNextMonthDate(current?: SimpleDate): SimpleDate {
    const nextMonth = this
      .toMoment(current)
      .add(1, 'month')
      .toObject();
    return this.toSimpleDate(nextMonth);
  }

  getPreviousMonthDate(current?: SimpleDate): SimpleDate {
    const prevMonth = this
      .toMoment(current)
      .subtract(1, 'month')
      .toObject();
    return this.toSimpleDate(prevMonth);
  }

  stringToSimpleDate(date: string): SimpleDate {
    const momentObj = moment(date, [moment.HTML5_FMT.DATE, moment.HTML5_FMT.DATETIME_LOCAL_SECONDS]).toObject();
    return this.toSimpleDate(momentObj);
  }

  simpleDateToDate(date: SimpleDate): Date {
    if (date.month) {
      date = { ...date, month: date.month - 1 };
    }
    return moment(date).toDate();
  }

  monthNameShort(month: number): string {
    return moment({month: month - 1}).format('MMM');
  }

  private toMoment(date?: SimpleDate) {
    if (date === undefined) {
      date = this.clock.now();
    }
    date = { ...date, month: date.month - 1 };
    return moment(date);
  }

  private toSimpleDate(momentObj: MomentObjectOutput): SimpleDate {
    return {
      year: momentObj.years,
      month: momentObj.months + 1,
      day: momentObj.date,
      hour: momentObj.hours,
      minute: momentObj.minutes,
      second: momentObj.seconds,
      millisecond: momentObj.milliseconds
    };
  }
}
